import { DashboardWidgetWidth } from '@/components/dashboard/model';
import { DashboardMetric } from '../../dashboard/model';
import {
  publisherDashboardDocumentSchema,
  publisherDashboardInheritedDateScope as inherit,
  PublisherDashboardWidgetType,
} from './widgetModel';

export const defaultPublisherDashboardDocument = publisherDashboardDocumentSchema.parse({
  version: 1,
  widgets: [
    metric('publisher-ad-requests', DashboardMetric.AdRequests),
    metric('publisher-ad-impressions', DashboardMetric.AdImpressions),
    metric('publisher-revenue', DashboardMetric.Revenue),
    {
      id: 'publisher-performance',
      type: PublisherDashboardWidgetType.PerformanceChart,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      metrics: [DashboardMetric.AdRequests, DashboardMetric.AdImpressions, DashboardMetric.Revenue],
    },
    {
      id: 'publisher-inventory',
      type: PublisherDashboardWidgetType.Inventory,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      pageSize: 20,
    },
  ],
});

function metric(id: string, metric: DashboardMetric) {
  return {
    id,
    type: PublisherDashboardWidgetType.Metric,
    width: DashboardWidgetWidth.Third,
    dateScope: inherit,
    metric,
  };
}
